import { AnyAction } from 'redux';
import {
  ORDER_RECEIVE,
  ORDER_ERROR,
  ORDER_CHANGE_MODE,
  ORDER_CHANGE_CURRENTPAGE,
  ORDER_SET_ORDER,
  ViewMode,
  ORDER_SET_IS_LOADING,
  RETURN_ORDER_RESPONSE_RECEIVE,
} from '../constants';
import { Order } from '../Types/Order';
import { error as errorReducer } from './Error.reducer';

export interface ORDER_STATE {
  mode: ViewMode;
  list: Order[];
  order?: Order;
  totalCount: number;
  showOnlyMyOrders: boolean;
  errors: any;
  isLoading: boolean;
}

export const DEFAULT_STATE: ORDER_STATE = {
  mode: ViewMode.List,
  list: [],
  totalCount: 0,
  showOnlyMyOrders: false,
  errors: {},
  isLoading: false,
};

export const DEFAULT_RETURN_ORDER_STATE: RETURN_ORDER_STATE = {
  success: false,
  qrCodeLink: '',
  errorSource: '',
  errors: {},
};

export interface RETURN_ORDER_STATE {
  orderId?: string;
  success?: boolean;
  qrCodeLink?: string;
  packBoxLabelCode?: string;
  errorSource?: string;
  errors?: any;
}

export const order = (
  state = DEFAULT_STATE,
  action: AnyAction
): ORDER_STATE => {
  const { type, payload } = action;
  switch (type) {
    case ORDER_RECEIVE:
    case ORDER_CHANGE_MODE:
    case ORDER_CHANGE_CURRENTPAGE:
    case ORDER_SET_ORDER:
    case ORDER_SET_IS_LOADING:
      return {
        ...state,
        errors: {},
        ...payload,
      };
    case ORDER_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    default:
      return state;
  }
};

export const returnOrder = (
  state = DEFAULT_RETURN_ORDER_STATE,
  action: AnyAction
): RETURN_ORDER_STATE => {
  const { type, payload } = action;
  switch (type) {
    case RETURN_ORDER_RESPONSE_RECEIVE:
      return {
        ...state,
        ...payload.returnOrderResponse,
      };
    default:
      return state;
  }
};
